import { usePWA } from '@/hooks/usePWA';
import { Button } from '@/components/ui';

export function PWAUpdateBanner(): JSX.Element | null {
  const { updateAvailable, applyUpdate } = usePWA();

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:bottom-4 md:left-auto md:right-4 md:max-w-sm z-50 animate-slide-up">
      <div className="bg-[var(--color-primary-500)] text-white rounded-lg shadow-[var(--shadow-overlay)] p-4 flex items-center gap-3">
        <div className="flex-1">
          <p className="text-sm font-medium">Доступна новая версия</p>
          <p className="text-xs opacity-80 mt-0.5">Обновите приложение для получения улучшений</p>
        </div>
        <Button
          variant="secondary"
          size="sm"
          onClick={applyUpdate}
        >
          Обновить
        </Button>
      </div>
    </div>
  );
}
